import React, { useEffect, useState } from "react";
import ProfileCard from "./ProfileCard"; // UI component only
import { progressService } from "../../../../../../services/progressService.js";

// 🔥 Auto unwrap nested payload/data
const unwrapPayload = (node) => {
  let current = node;
  while (
    current &&
    typeof current === "object" &&
    (current.payload || current.data)
  ) {
    current = current.payload || current.data;
  }
  return current;
};

const ProfileCardWithData = ({ userId }) => {
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProfile = async () => {
      try {
        setLoading(true);

        console.log("🔵 Fetching profile for userId:", userId);

        // API CALL
        const res = await progressService.getUserDataForSection(
          userId,
          "course_career_progression",
          "identity",
          "current_identity_reflection"
        );

        console.log("🔥 RAW RESPONSE:", res);

        // extract first level
        const root = res?.data?.payload || res?.payload;

        // unwrap deeply nested payload/data
        const payload = unwrapPayload(root);

        console.log("🎯 CLEAN PAYLOAD:", payload);

        if (!payload) {
          setFormData(null);
          return;
        }

        // SET FINAL FORM DATA
        const cleaned = {
          userName: payload.userName || "",
          profileImage: payload.profileImage || "",
          currentTitle: payload.currentTitle || "",
          company: payload.company || "",
          location: payload.location || "",
          salary: payload.salary || "",
          experienceYears: payload.experienceYears || "",
          experienceMonths: payload.experienceMonths || "",
          technicalSkills: payload.technicalSkills || "",
          behaviors: payload.behaviors || "",
          advice: payload.advice || "",
          hobbies: payload.hobbies || "",
        };

        console.log("✅ CLEANED DATA FOR CARD:", cleaned);

        setFormData(cleaned);
      } catch (error) {
        console.error("❌ Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) loadProfile();
  }, [userId]);

  // Loading UI
  if (loading || !formData) {
    return <p className="text-center text-gray-500 mt-5">Loading profile...</p>;
  }

  return (
    <ProfileCard
      formData={formData}
      editableName={false}
      headerLabel="Current State"
      showKnownFor={true}
      showCoreValues={false}
    />
  );
};

export default ProfileCardWithData;
